/****************************************************
 * Module Name:  polProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class PolProxy {
  static GetAllPol = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/pol",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllPolMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/pol/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSinglePol = (polId, callback) => {
    let params = {
      id: polId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/pol",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckPolAvailable = (pol, callback) => {
    let params = {
      pol: pol,
    };

    restAPICall(
      Constants.MANAGER_URL + "/pol/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddPol = (pol, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/pol",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(pol),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdatePol = (pol, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/pol",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(pol),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
